"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBarRenderItem = void 0;
const react_1 = __importDefault(require("react"));
const AppBarFill_1 = require("../controls/AppBarFill/AppBarFill");
const AppBarLink_1 = require("../controls/AppBarLink/AppBarLink");
const AppBarSeparator_1 = require("../controls/AppBarSeparator/AppBarSeparator");
const AppBarItemType_1 = require("../types/AppBarItemType");
const appBarRenderItem = (itemProps) => {
    const { type } = itemProps, rest = __rest(itemProps, ["type"]);
    switch (type) {
        case AppBarItemType_1.APP_BAR_ITEM_TYPE.custom:
            return itemProps.render();
        case AppBarItemType_1.APP_BAR_ITEM_TYPE.fillSpace:
            return react_1.default.createElement(AppBarFill_1.AppBarFill, Object.assign({}, rest));
        case AppBarItemType_1.APP_BAR_ITEM_TYPE.link:
            return react_1.default.createElement(AppBarLink_1.AppBarLink, Object.assign({}, rest));
        case AppBarItemType_1.APP_BAR_ITEM_TYPE.separator:
            return react_1.default.createElement(AppBarSeparator_1.AppBarSeparator, Object.assign({}, rest));
    }
};
exports.appBarRenderItem = appBarRenderItem;
//# sourceMappingURL=appBarRenderItem.js.map